import Link from '@components/Link';
import React, { useContext } from 'react';

import { GlobalContext } from '@context/GlobalContext';

// Styles
import './_ButtonCta.scss';

ButtonCta.defaultProps = {
    theme: 'dark',
    type: 'primary', // secondary, inline
};

export default function ButtonCta(props) {
    let mod_class = [
        'ButtonCta',
        props.type !== undefined ? 'is-' + props.type : '',
    ];
    mod_class = mod_class.join(' ');

    const [globalState, setGlobalState] = useContext(GlobalContext);

    // Open Modal
    function ScrollDown() {
        console.log('Scroll Down');
        window.scrollTo({
            top: 700,
            left: 0,
            behavior: 'smooth',
        });
    }

    function openModal(target) {
        switch (target) {
            case 'signup':
                return setGlobalState({
                    signup_modal_open: !globalState.signup_modal_open,
                });
            case 'individual':
                return setGlobalState((prevData) => ({
                    ...prevData,
                    individual_modal_open: !globalState.individual_modal_open,
                }));
            case 'therapist':
                return setGlobalState((prevData) => ({
                    ...prevData,
                    therapist_modal_open: !globalState.therapist_modal_open,
                }));
            case 'business':
                return setGlobalState((prevData) => ({
                    ...prevData,
                    business_modal_open: !globalState.business_modal_open,
                }));
            default:
                return console.log('action unassigned');
        }
    }

    function checkAction() {
        switch (props.action) {
            case 'Scroll down':
                return ScrollDown();
            case 'Open individual modal':
                return openModal('individual');
            case 'Open therapist modal':
                return openModal('therapist');
            case 'Open business modal':
                return openModal('business');
            case 'Open signup modal':
                return openModal('signup');
            default:
                return console.log('action unassigned');
        }
    }

    function renderLinks() {
        if (props.to !== undefined) {
            return (
                <Link className={mod_class} to={props.to}>
                    {props.text}
                </Link>
            );
        } else if (props.goal === 'submit') {
            return (
                <button
                    className={mod_class}
                    id={props.id}
                    name={props.name}
                    label={props.label}
                    type="Submit"
                >
                    {props.label}
                </button>
            );
        } else if (props.className !== undefined) {
            return (
                <button
                    className={props.className}
                    onClick={() => checkAction()}
                >
                    {props.text}
                </button>
            );
        } else {
            return (
                <button className={mod_class} onClick={() => checkAction()}>
                    {props.text}
                </button>
            );
        }
    }

    return renderLinks();
}
